const formatMoneyStringToNumber = (value?: string | number) => {
  if (!value) return 0;
  if (typeof value === 'number') return value;

  return Math.round(parseFloat(`${value}`.replace(/,/g, '')) * 100) / 100;
};

export default formatMoneyStringToNumber;
